var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.19041 12.4407C0.512579 13.1463 1.17557 13.584 1.92191 13.584H3.65465C3.9395 14.9638 5.10503 16 6.49944 16C7.89384 16 9.05937 14.9638 9.34546 13.5853H11.0782C11.8245 13.5853 12.4875 13.1476 12.8097 12.442C13.1306 11.739 13.0411 10.9262 12.5759 10.3187C11.5123 8.92968 10.9488 7.60865 10.9488 6.4993C10.9488 4.89211 10.9488 -6.23062e-06 6.49944 -6.23062e-06C2.05003 -6.23062e-06 2.05003 4.89081 2.05003 6.49799C2.05003 7.60734 1.48779 8.92837 0.423018 10.3187C-0.0409537 10.9249 -0.130514 11.739 0.19041 12.4407ZM7.03182 14.04C6.33027 14.04 5.20081 14.2334 4.95203 13.5853L4.5875 14.04C4.33996 14.6868 7.73338 14.04 7.03182 14.04ZM1.39326 11.1366C2.65456 9.48893 3.29392 7.92878 3.29392 6.49799C3.29392 1.89595 5.15466 1.58397 6.49944 1.30534C7.99211 1.30534 3.36286 0.423256 3.36286 5.0253C3.36286 6.45609 0.0510944 10.6323 1.31116 12.2786C1.47535 12.4942 11.9161 13.3867 11.6865 11.8762C11.5708 12.1271 11.3444 12.2786 11.077 12.2786H1.92067C1.65323 12.2786 1.42684 12.1284 1.31116 11.8762C1.19796 11.6279 1.22906 11.3509 1.39326 11.1366Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellClicked);
export default __webpack_public_path__ + "static/media/bell-clicked.1e254eda5b64068cfae9b98a4771756f.svg";
export { ForwardRef as ReactComponent };